import React, { useEffect, useState } from 'react';
import { isValidPhoneNumber } from 'react-phone-number-input';
import { useParams } from '../../../services/routing/useRouteInfo';
import { Telephone } from '../../shared/links/telephone';
import { FormMode, FormView } from '../../shared/view/form';


export const SystemForm = () => {

    let { id } = useParams();

    const [len, setLen] = useState(id?.split(',')?.length ?? 0);

    useEffect(() => {
        setLen(id?.split(',')?.length ?? 0);
    }, [id]);

    return <FormView
        ids={id?.split(',').map(i => parseInt(i ?? ''))}
        resourceName={len > 1 ? 'Systems' : 'System'}
        processData={d => { if (d.note === null) d.note = ''; return d; }}
        nameFunction={r => r?.name}
        restEndpoint='/systemAccess'
        listLocation='/systemAccess'
        formMode={len === 0 ? FormMode.Add : FormMode.Edit}
        format={{
            'name': {
                max: 50,
            },
            'status': {
                type: 'switch',
                default: 1,
                forChangeLog: v => ['Ignored', 'Normal', 'Not Enough Business', 'Closed Access'][v.status],
                switchData: len > 1 ?  [
                    {
                        label: 'Ignored',
                        value: null,
                        color: 'var(--text-light-color)',
                    },
                    {
                        label: 'Normal',
                        value: 1,
                        color: 'var(--success-light-color)',
                    },
                    {
                        label: 'Not Enough Business',
                        value: 2,
                        color: 'var(--warning-light-color)',
                    },
                    {
                        label: 'Closed Access',
                        value: 3,
                        color: 'var(--error-light-color)',
                    }
                ] : [
                    {
                        label: 'Normal',
                        value: 1,
                        color: 'var(--success-light-color)',
                    },
                    {
                        label: 'Not Enough Business',
                        value: 2,
                        color: 'var(--warning-light-color)',
                    },
                    {
                        label: 'Closed Access',
                        value: 3,
                        color: 'var(--error-light-color)',
                    }
                ],
            },
            'url': {
                max: 1000,
                required: false,
            },
            'helpITPhone': {
                label: 'IT Helpdesk Phone',
                type: 'tel',
                required: false,
                forChangeLog: v => <Telephone number={v.helpITPhone} extension={v.helpITPhoneExtension} />,
                validate:  v => !v.helpITPhone && isValidPhoneNumber(v.helpITPhone ?? '') ? 'Invalid phone number' : null,
            },
            'helpITPhoneExtension': {
                label: 'IT Helpdesk Phone Extension',
                max: 50,
                required: false,
                // forChangeLog: v => <Telephone number={v.helpITPhone} extension={v.helpITPhoneExtension} />,
            },
            'supportContactName': {
                max: 50,
                required: false,
            },
            'supportContactEmail': {
                max: 50,
                type: 'email',
                required: false,
            },
            //Only edit notes individually
            ...(len <= 1 ? {
                'note': {
                    max: 4000,
                    rows: 4,
                    type: 'textarea',
                    required: false,
                }
            } : {})
        }}
    />
}